import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { MobileCallButton } from "./MobileCallButton";

export const Layout = ({ children }) => (
  <div className="min-h-screen bg-[#0A0A0A]">
    <Navbar />
    <main className="pt-20">{children}</main>
    <Footer />
    <MobileCallButton />
  </div>
);
